// import $ from 'jquery';
import 'what-input';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper, { Navigation, Autoplay, Mousewheel } from 'swiper';

gsap.registerPlugin(ScrollTrigger);

// configure Swiper to use modules
Swiper.use([Navigation, Autoplay, Mousewheel]);

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
// window.jQuery = $;
// require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


// $(document).foundation();


// listen for the DOMContentLoaded event, then bind our function
document.addEventListener('DOMContentLoaded', function() {
    // runConsoleCheck();

    preloader();
    marquee();
    pinterLayers();
    logoReveal();
    titleReveal();
    appSequence();
    beerScroll();
    howItWorksPinter();
    subscribeSequence();
    engineeringSequence(); //Memory issue
    if (typeof fbcAssets !== 'undefined') {
        fbcSequence(fbcAssets);
    }
    reviewsScroll();
    parallax();
    fadeIn();
    relatedProductsScroll();
    testimonialsScroll();
    galleryScroll();
    newsScroll();
    videoScroll();
    alertFunction();
    steppedShopSummary();
});

function runConsoleCheck() {
    console.log('ready');
}

function preloader() {
    const tl = gsap.timeline();

    tl.fromTo(
        ".preloader__logo",
        { opacity: 0 },
        { opacity: 1, ease: "power4.inOut" },
    ).fromTo(
        ".preloader__screen",
        { y: "100%" },
        { duration: 1.5, y: "0", ease: "power4.inOut" },
        "-=0.3"
    ).fromTo(
        ".preloader",
        { y: "0%" },
        { duration: 1.5, y: "-100%", ease: "power4.inOut" },
        "-=1"
    );
}

function marquee() {
    const marqueeText = gsap.utils.toArray('.marquee-text__part');

    marqueeText.forEach((marquee, i) => {
        let tween = gsap.to(marquee, {xPercent: -100, repeat: -1, duration: 25, ease: "linear"}).totalProgress(0.5);
        gsap.set(".marquee-text__wrapper", {xPercent: -50});
    });
}

function fadeIn() {
    const fade = gsap.utils.toArray('.fade-in');

    fade.forEach((fade, i) => {
        const anim = gsap.fromTo(fade, {autoAlpha: 0, y: 50}, {duration: 1, autoAlpha: 1, y: 0});
        ScrollTrigger.create({
            trigger: fade,
            animation: anim
        });
    });
}

function pinterLayers() {
    gsap.set('#pinter-layers', {autoAlpha:1})

    var action = gsap.timeline({
    scrollTrigger: {
        trigger: ".home-intro__layers",
        pin: true,   
        start: 'center center',
        scrub: 0.2
    },
    defaults:{duration:1, ease:'none'}
    })

    .from('#poly01', {attr:{points:"0,527 775,527 775,527 0,527 0,0"} },1)
    .from('#poly03', {attr:{points:"0,527 775,527 775,527 0,527 0,0"} }, '+=1')
    .to({}, {})
}

function logoReveal() {
    const sections = document.querySelectorAll('.masthead-home');

    sections.forEach((section, index, arr) => {
        const textrev = gsap.timeline();

        textrev.from(".masthead-home__logo svg", 2, {
            y: "100%",
            ease: "power4.out",
            delay: 1.5,
            stagger: {
                amount: 0.2,
            },
        });
    })
}

function titleReveal() {
    const sections = document.querySelectorAll('.title-reveal');

    sections.forEach((section, index, arr) => {
        const textWrapper = document.querySelector('h1');
        textWrapper.innerHTML = textWrapper.textContent.replace(/[\w]+\b\S*/g, "<span class='word'><span>$&</span></span>");

        const textrev = gsap.timeline();

        textrev.from(".word span", 2, {
            y: "150%",
            ease: "power4.out",
            delay: 1.5,
            stagger: {
                amount: 0.2,
            },
        });
    })
}

function appSequence() {
    const sections = gsap.utils.toArray('.app-viewer');

    var frame_count  = 9,
    offset_value = 160;

    sections.forEach((section) => {

        gsap.to(sections, {
            backgroundPosition: (-offset_value * frame_count * 2) + "px 50%",
            ease: "steps(" + frame_count + ")", // use a stepped ease for the sprite sheet
            scrollTrigger: {
                trigger: ".masthead-app__sequence",
                start: "top top",
                end: "+=" + (frame_count * offset_value),
                pin: true,
                scrub: true
            }
        });

    })
}

function beerScroll() {
    const sections = gsap.utils.toArray(".beer-scroll__section");
    let maxWidth = 0;

    const getMaxWidth = () => {
        maxWidth = 0;
        sections.forEach((section) => {
            maxWidth += section.offsetWidth;
        });
    };
    getMaxWidth();
    ScrollTrigger.addEventListener("refreshInit", getMaxWidth);

    gsap.to(sections, {
        x: () => `-${maxWidth - window.innerWidth}`,
        ease: "none",
        scrollTrigger: {
            trigger: ".beer-scroll",
            pin: true,
            scrub: true,
            end: () => `+=${maxWidth}`,
            invalidateOnRefresh: true
        }
    });

    sections.forEach((sct, i) => {
        ScrollTrigger.create({
            trigger: sct,
            start: () => 'top top-=' + (sct.offsetLeft - window.innerWidth/2) * (maxWidth / (maxWidth - window.innerWidth)),
            end: () => '+=' + sct.offsetWidth * (maxWidth / (maxWidth - window.innerWidth)),
            toggleClass: {targets: sct, className: "active"}
        });
    });
}

function howItWorksPinter() {
    const sections = gsap.utils.toArray(".how-it-works-pinter__section");
    let maxWidth = 0;

    const getMaxWidth = () => {
        maxWidth = 0;
        sections.forEach((section) => {
            maxWidth += section.offsetWidth;
        });
    };
    getMaxWidth();
    ScrollTrigger.addEventListener("refreshInit", getMaxWidth);

    gsap.to(sections, {
        x: () => `-${maxWidth - window.innerWidth}`,
        ease: "none",
        scrollTrigger: {
            trigger: ".how-it-works-pinter",
            pin: true,
            scrub: true,
            end: () => `+=${maxWidth}`,
            invalidateOnRefresh: true
        }
    });

    sections.forEach((sct, i) => {
        ScrollTrigger.create({
            trigger: sct,
            start: () => 'top top-=' + (sct.offsetLeft - window.innerWidth/2) * (maxWidth / (maxWidth - window.innerWidth)),
            end: () => '+=' + sct.offsetWidth * (maxWidth / (maxWidth - window.innerWidth)),
            toggleClass: {targets: sct, className: "active"}
        });
    });
}

function subscribeSequence() {
    const sections = gsap.utils.toArray('.viewer');

    var frame_count  = 9,
    offset_value = 160;

    sections.forEach((section) => {

        gsap.to(sections, {
            backgroundPosition: (-offset_value * frame_count * 2) + "px 50%",
            ease: "steps(" + frame_count + ")", // use a stepped ease for the sprite sheet
            scrollTrigger: {
                trigger: ".subscribe-scroll-sequence__sequence",
                start: "top top",
                end: "+=" + (frame_count * offset_value),
                pin: true,
                scrub: true
            }
        });

    })
}

function engineeringSequence() {

    const sections = document.querySelectorAll('.engineering-scroll-sequence');

    sections.forEach((section, index, arr) => {
        ScrollTrigger.saveStyles(".engineering-scroll-sequence__text .engineering-scroll-sequence__item")

        var targets = document.querySelectorAll(".engineering-scroll-sequence__text .engineering-scroll-sequence__item");

        targets.forEach(target => {
            const tl = gsap.timeline({
                defaults: {duration: 1},
                scrollTrigger: {
                    trigger: target,
                    scrub: true,
                    start: "top top",
                    end: "bottom top",
                    pin: true
                }
            })
            .from(target, {opacity: 0, duration: 0.5}, 0)
            .to(target, {opacity: 0, duration: 0.5}, 1)
        });
      
//        console.clear();

        const canvas = document.getElementById("engineering-sequence");
        const context = canvas.getContext("2d");

        canvas.width = 1158;
        canvas.height = 770;

        const frameCount = 147;
        const currentFrame = index => (
            `https://www.apple.com/105/media/us/airpods-pro/2019/1299e2f5_9206_4470_b28e_08307a42f19b/anim/sequence/large/01-hero-lightpass/${(index + 1).toString().padStart(4, '0')}.jpg`
        );

        const images = []
        const engseq = {
            frame: 0
        };

        for (let i = 0; i < frameCount; i++) {
            const img = new Image();
            img.src = currentFrame(i);
            images.push(img);
        }

        gsap.to(engseq, {
            frame: frameCount - 1,
            snap: "frame",
            scrollTrigger: {
                trigger: ".engineering-scroll-sequence",
                start: "top top",
                scrub: 0.5,
                pin: true
            },
            onUpdate: render
        });

        images[0].onload = render;

        function render() {
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.drawImage(images[engseq.frame], 0, 0);
        }
    })
}

function fbcSequence(assets) {
    //console.clear();
    
    const sections = document.querySelectorAll('.how-it-works-fbc');
    
    sections.forEach((section, index, arr) => {
        const canvas = document.getElementById("fbc-sequence");
        const context = canvas.getContext("2d");
        canvas.width = 1214;
        canvas.height = 1092;

        const frameCount = 243;

        const images = []
        const fbcseq = {
            frame: 0
        };

        for (let i = 0; i < frameCount; i++) {
        const img = new Image();
            img.src = assets[i];
            images.push(img);
        }

        gsap.to(fbcseq, {
            frame: frameCount - 1,
            snap: "frame",
            scrollTrigger: {
                trigger: ".how-it-works-fbc",
                start: "top top",
                end: "bottom -150%", // When the bottom of the trigger goes 150% past the top of the scroller
                scrub: 0.5,
                pin: true
            },
            onUpdate: render // use animation onUpdate instead of scrollTrigger's onUpdate
        });

        images[0].onload = render;

        function render() {
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.drawImage(images[fbcseq.frame], 0, 0); 
        }
    })
}

function reviewsScroll() {
    gsap.utils.toArray('.reviews__group').forEach((section, index) => {
        const w = section.querySelector('.reviews__wrapper');
        const [y, yEnd] = (index % 2) ? ['100%', (w.scrollHeight - section.offsetHeight) * -1] : [w.scrollHeight * -1, 0];
        gsap.fromTo(w, {  y  }, {
            y: yEnd,
            scrollTrigger: { 
                trigger: ".reviews",
                start: "top top",
                end: "bottom bottom",
                scrub: 0.5
            }
        });
    });
}

function parallax() {
    const p1 = gsap.utils.toArray('.p-content');
    p1.forEach(parallax => {
        gsap.to(parallax, { 
            yPercent: -50,
            ease: "none",
            scrollTrigger: {
                trigger: parallax,
                scrub: true
            }
        })
    });

    const p2 = gsap.utils.toArray('.p-content-invert');
    p2.forEach(parallaxInvert => {
        gsap.to(parallaxInvert, { 
            yPercent: 20,
            ease: "none",
            scrollTrigger: {
                trigger: parallaxInvert,
                scrub: true
            }
        })
    });
}

function relatedProductsScroll() {
    new Swiper('.related-products .swiper-container', {
        slidesPerView: '1',
        watchOverflow: true,
        mousewheel: {
            forceToAxis: true,
        },
        speed: 400,
        breakpoints: {
            640: {
                slidesPerView: '3',
            },
        },
    });
}

function newsScroll() {
    new Swiper('.more-posts .swiper-container', {
        slidesPerView: '1',
        spaceBetween: 10,
        watchOverflow: true,
        mousewheel: {
            forceToAxis: true,
        },
        speed: 400,
        breakpoints: {
            640: {
                spaceBetween: 0,
                slidesPerView: '3',
            },
        },
    });
}

function testimonialsScroll() {
    new Swiper('.testimonials .swiper-container', {
        slidesPerView: '1',
        spaceBetween: 10,
        watchOverflow: true,
        mousewheel: {
            forceToAxis: true,
        },
        speed: 400,
    });
}

function galleryScroll() {
    new Swiper('.gallery-slider', {
        effect: 'fade',
        slidesPerView: '1',
        spaceBetween: 10,
        watchOverflow: true,
        mousewheel: {
            forceToAxis: true,
        },
        navigation: {
          nextEl: ".gallery-slider .swiper-button-next",
          prevEl: ".gallery-slider .swiper-button-prev",
        },
        speed: 400,
        breakpoints: {
            1024: {
                navigation: false
            },
        },
    });
}

function videoScroll()
{
    const breakpoint = 1024;
    const videos = document.getElementsByTagName('video');
    const videoKeys = Object.keys(videos);

    if (videoKeys.length > 0) {
        videoKeys.forEach(objectKey => {
            if (videos[objectKey].classList.contains('responsive-video')) {
                const src = window.innerWidth > breakpoint ? videos[objectKey].getAttribute('data-desktop') : videos[objectKey].getAttribute('data-mobile');
                let source = document.createElement('source');
                source.src = src;
                source.type = 'video/mp4';
                videos[objectKey].appendChild(source);
            }

            videoPlay(videos[objectKey]);
        })
    }
}

function isScrolledIntoView(el)
{
    var bounding = el.getBoundingClientRect();
    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function videoPlay(el) {
    el.play();
}

function alertFunction() {
    const buttons = document.querySelectorAll('.alert-close');

    buttons.forEach(function (btn) {
        btn.addEventListener("click", function () {
            this.parentNode.classList.add("hide");
        });
    });
}

function steppedShopSummary() {
    const summary = document.getElementById('mylist');

    if(summary){
        window.onscroll = function() {
            const stickSummary = document.getElementById('sticky-summary');
            var bounding = summary.getBoundingClientRect();


            if(bounding.top <= (window.innerHeight || document.documentElement.clientHeight)){
                stickSummary.classList.remove('show')
            }
            else if(!isScrolledIntoView(summary)){
                stickSummary.classList.add('show')
            }
            else{
                stickSummary.classList.remove('show')
            }
        }
    }
}

